import styled from "@emotion/styled";

import { sizeToken } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";

export const LoaderContainer = styled.div({
    height: sizeToken(50),
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});
